import {
  EmptyState,
  FlexBox,
  SectionLoader,
} from '@airship-platform/jam-web/components';
import { useMemo } from 'react';
import { useAppointmentHistory } from '../../../data-access/appointmentHistory';
import ProposalTemplatesHistoryQueryList from './ProposalTemplatesHistoryQueryList';

const ProposalTemplateOptionQueryResults: React.FC = () => {
  const { appointmentHistory, isLoading, isLoaded } = useAppointmentHistory();

  const isLoadedAll = !(isLoading && !isLoaded);

  const filteredAppointments = useMemo(
    () =>
      appointmentHistory.filter(
        (appointment) =>
          appointment.proposals.length &&
          appointment.proposals.some((p) => p.optionsCount)
      ),
    [appointmentHistory]
  );

  return (
    <FlexBox flexDirection={'column'} gap={2} width={'100%'}>
      {isLoadedAll ? (
        filteredAppointments.length ? (
          <ProposalTemplatesHistoryQueryList templates={filteredAppointments} />
        ) : (
          <EmptyState title={'No proposals'} subtitle={''} />
        )
      ) : (
        <SectionLoader
          isLoading={!isLoadedAll}
          title="Loading Previous Proposals"
        />
      )}
    </FlexBox>
  );
};

export default ProposalTemplateOptionQueryResults;
